import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FileTextIcon, ShoppingCartIcon, ClipboardListIcon, ArrowRightIcon } from 'lucide-react';
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="comprar" className="w-full bg-cream py-16 md:py-28" ref={ref} data-id="element-120">
      <div className="max-w-prose mx-auto px-5" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="font-serif text-lg md:text-xl leading-[1.85] text-charcoal/90 space-y-6 mb-12" data-id="element-122">
          <p data-id="element-123">
            Si hoy estás cansada de mirarte y pensar{' '}
            <em data-id="element-124">"no entiendo qué me pasa"</em>… esto te devuelve algo que vale
            más que un número:
          </p>

          <p className="text-2xl md:text-3xl font-sans font-bold text-charcoal" data-id="element-125">
            Claridad.
          </p>

          <p data-id="element-126">Y con claridad, vuelve el control.</p>
        </motion.div>

        {/* Offer Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.25
      }} className="bg-white rounded-2xl shadow-lg shadow-charcoal/8 border border-gold/20 overflow-hidden" data-id="element-127">
          {/* Card Header */}
          <div className="bg-gradient-to-r from-charcoal to-charcoal/90 px-6 md:px-8 py-5" data-id="element-128">
            <h2 className="font-sans font-bold text-xl md:text-2xl text-cream" data-id="element-129">
              Anti-Hinchazón 14 Días{' '}
              <span className="text-terracotta-light" data-id="element-130">(Peri 30+)</span>
            </h2>
          </div>

          <div className="px-6 md:px-8 py-8" data-id="element-131">
            {/* What's included */}
            <div className="space-y-3 mb-8" data-id="element-132">
              <div className="flex items-center gap-3 font-sans text-base text-charcoal/80" data-id="element-133">
                <FileTextIcon className="w-4 h-4 text-sage flex-shrink-0" data-id="element-134" />
                <span data-id="element-135">PDF completo con plan de 14 días</span>
              </div>
              <div className="flex items-center gap-3 font-sans text-base text-charcoal/80" data-id="element-136">
                <ShoppingCartIcon className="w-4 h-4 text-sage flex-shrink-0" data-id="element-137" />
                <span data-id="element-138">Lista de compras (medidas USA)</span>
              </div>
              <div className="flex items-center gap-3 font-sans text-base text-charcoal/80" data-id="element-139">
                <ClipboardListIcon className="w-4 h-4 text-sage flex-shrink-0" data-id="element-140" />
                <span data-id="element-141">Trackers imprimibles</span>
              </div>
              <div className="flex items-center gap-3 font-sans text-base text-charcoal/80" data-id="element-142">
                <FileTextIcon className="w-4 h-4 text-sage flex-shrink-0" data-id="element-143" />
                <span data-id="element-144">Plan anti-rebote para fines de semana</span>
              </div>
            </div>

            {/* Price */}
            <div className="flex items-baseline gap-2 mb-8" data-id="element-145">
              <span className="font-sans font-bold text-4xl md:text-5xl text-charcoal" data-id="element-146">
                US$11.99
              </span>
              <span className="font-sans text-lg text-charcoal/50 line-through" data-id="element-147">
                US$29
              </span>
              <span className="ml-2 font-sans text-sm font-medium text-terracotta bg-terracotta/10 px-2.5 py-1 rounded-full" data-id="element-148">
                Precio de lanzamiento
              </span>
            </div>

            {/* CTA Button */}
            <a href="https://tiendadigitaljj.com//cart/43446651256910:1" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-2 w-full bg-terracotta hover:bg-terracotta-dark text-white font-sans font-semibold text-lg py-4 px-8 rounded-xl transition-colors duration-200 shadow-md shadow-terracotta/25" data-id="element-149">
              Descarga 14 días Anti-Hinchazón
              <ArrowRightIcon className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" data-id="element-150" />
            </a>

            <p className="font-serif text-sm text-charcoal/50 text-center mt-4" data-id="element-151">
              Empieza hoy mismo con el Día 1: "limpieza de variables" sin drama.
            </p>
          </div>
        </motion.div>

        {/* Disclaimer */}
        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="font-serif text-sm text-charcoal/40 text-center mt-8 max-w-md mx-auto leading-relaxed" data-id="element-152">
          Descarga inmediata en formato PDF. Este producto es una guía
          educativa, no sustituye consejo médico profesional.
        </motion.p>
      </div>
    </section>;
}